import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { procedureGroupList } from "../../../../../../../services/procedureGroup.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const ProcedureGroup = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(procedureGroupList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={options}
        name="uBusIntegrationRuleMovProcedureGroups"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "procedure_group")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
